import { Box, Grid } from '@mui/material';
import { validateNotNullOrUndefined } from '@vy/utils';
import { Helmet } from 'react-helmet';
import { useSearchParams } from 'react-router-dom';
import loginBackground from '../../../assets/images/login-background.png';
import { RegisterConfirmationPageForm } from './register-confirmation-page-components/RegisterConfirmationPageForm';

export const RegisterConfirmationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  validateNotNullOrUndefined(token, 'token');

  return (
    <>
      <Helmet>
        <title>Confirm User</title>
      </Helmet>
      <Grid container style={{ height: '100vh', overflow: 'hidden' }}>
        <Grid
          size={{
            lg: 5
          }}
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
          <RegisterConfirmationPageForm token={token} />
        </Grid>
        <Grid
          size={{
            lg: 7
          }}
          sx={{
            display: { xs: 'none', lg: 'flex' },
            background: '#E7F2FF',
            alignItems: 'center',
            justifyContent: 'flex-end',
            overflow: 'hidden',
            pl: '7%'
          }}>
          <Box
            component="img"
            src={loginBackground}
            alt="Vayu dashboard preview"
            sx={{
              display: 'block',
              maxWidth: '100%',
              maxHeight: '100%',
              width: '100%',
              height: 'auto',
              borderRadius: '24px 0 0 24px',
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
